module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NamMXE/tc-custom/9781609254964.jpg?1718106504526",
      "alt": "This image is the cover for the book Meeting the Monkey Halfway"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Meeting the Monkey Halfway\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An American Buddhist monk in the Theravada tradition offers wisdom and spiritual practices on attaining mindful presence.")]), _c('br'), _c('br'), _vm._v("Simple and straightforward, this “little book” is a distillation of twenty years of a Buddhist monk’s meditation practice. With a sense of reverence and respect for everything, Ajahn Sumano Bhikkhu shows us how to use only what we need, and then to use these few things carefully and with discrimination. "), _c('i', [_vm._v("Meeting the Monkey Halfway")]), _vm._v(" is his personal story, and through his story he will help us to open our hearts and relearn the compassion of the Buddha.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ajahn Sumano Bhikkhu, Emily Popp\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Samuel Weiser, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0